import { useCallback } from 'react';
import { useAuthentication } from '@topcon/topcon-utils';

import { AppRoutes } from '../app/routes/utils';
import { useRequestBusinessPartnerRegistrationToken } from '../pages/RequestBusinessPartner/businessPartnerRequest.mutations';

function useLoginRedirect() {
  const authenticationService = useAuthentication();
  const { mutateAsync: requestRegistrationToken } = useRequestBusinessPartnerRegistrationToken();

  const redirectWithRegistrationToken = useCallback(
    async (businessPartnerRequestId: string) => {
      try {
        const { registrationToken } = await requestRegistrationToken(businessPartnerRequestId);
        const loginUrl = new URL(authenticationService.getLoginURL(), window.location.origin);

        loginUrl.searchParams.set('register', registrationToken);
        loginUrl.searchParams.set('switch', 'nobp');
        loginUrl.searchParams.set('redirect_url', AppRoutes.CompaniesList);

        window.location.replace(loginUrl.toString());
      } catch {
        authenticationService.login();
      }
    },
    [authenticationService, requestRegistrationToken]
  );

  return { redirectWithRegistrationToken };
}

export default useLoginRedirect;
